import React, { useState } from 'react';
import { sendOtp } from '../../api/authAPI';


const PhoneNumberInput = ({ onContinue,handleSteps }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sendOtp(`+91${phoneNumber}`);
      onContinue(`+91${phoneNumber}`);
    } catch (error) {
      console.error('Error sending OTP:', error);
      // Handle error, e.g., show an error message
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h4>Login or Signup</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Phone Number</label>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">+91</span>
            </div>
            <input
              type="tel"
              className="form-control"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter phone number"
              required
            />
          </div>
        </div>
        <p>
          By continuing, I agree to the <a href="#">Terms of Use</a> &{' '}
          <a href="#">Privacy Policy</a>
        </p>
        <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
          {loading ? 'Sending OTP...' : 'Continue'}
        </button>
        <p>
          Have trouble logging in? <a href="#">Get help</a>
        </p>
        <p>
          Log in using <a href="#" onClick={handleSteps}>Password</a>
        </p>
      </form>
    </div>
  );
};

export default PhoneNumberInput;
